import { createApi } from 'store/slices/createApi';
import { createBaseQuery } from '../../slices';
import { TAG_TYPES } from 'types/services';

export const heliosApi = createApi({
  reducerPath: 'heliosApi',
  baseQuery: createBaseQuery({
    extendedUrl: 'helios',
  }),

  tagTypes: [
    TAG_TYPES.DATASOURCES,
    TAG_TYPES.NOTIFICATION_TEMPLATES,
    TAG_TYPES.TABLE,
    TAG_TYPES.TABLE_DETAIL,
    TAG_TYPES.TEMPLATES,
    TAG_TYPES.USER_DEFINED_ATTRIBUTES,
    TAG_TYPES.AGGREGATION_GROUPS,
    TAG_TYPES.TEMPLATE_FUNCTIONS,
    TAG_TYPES.TEMPLATE_ROLES,
    TAG_TYPES.FUNCTIONS,
    TAG_TYPES.DATA_HELIOS,
    TAG_TYPES.DATA_TABLES_HELIOS,
    TAG_TYPES.IMPORT_TEMPLATES,
    TAG_TYPES.CHECK_USERS,
    TAG_TYPES.FILES,
    TAG_TYPES.FORMS,
    TAG_TYPES.FILES,
    TAG_TYPES.HELIOS_USER_FILTERS,
    TAG_TYPES.FAVORITE_TEMPLATES,
  ],

  endpoints: () => ({}),
});
